import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Input } from '../ui/input';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '../ui/tooltip';

export interface BreadcrumbSegment {
  label: string;
  onClick?: () => void;
}

interface CanvasBreadcrumbProps {
  segments: BreadcrumbSegment[];
  editableValue: string;
  onEditableChange: (value: string) => void;
}

export function CanvasBreadcrumb({ segments, editableValue, onEditableChange }: CanvasBreadcrumbProps) {
  return (
    <div className="flex items-center gap-1 min-w-0">
      {segments.map((segment, i) => (
        <React.Fragment key={i}>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={segment.onClick}
                disabled={!segment.onClick}
                className="max-w-[140px] truncate text-sm text-muted-foreground hover:text-foreground transition-colors disabled:hover:text-muted-foreground shrink-0"
              >
                {segment.label}
              </button>
            </TooltipTrigger>
            <TooltipContent>{segment.label}</TooltipContent>
          </Tooltip>
          <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50 shrink-0" />
        </React.Fragment>
      ))}
      <Input
        value={editableValue}
        onChange={(e) => onEditableChange(e.target.value)}
        className="h-8 w-40 min-w-0 text-sm font-medium rounded-lg"
      />
    </div>
  );
}
